import { render, staticRenderFns } from "./AsideMenuList.vue?vue&type=template&id=0de87846&"
import script from "./AsideMenuList.vue?vue&type=script&lang=js&"
export * from "./AsideMenuList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports